import { render, staticRenderFns } from "./CommissionDetails.vue?vue&type=template&id=ccb3c904&scoped=true"
import script from "./CommissionDetails.vue?vue&type=script&lang=js"
export * from "./CommissionDetails.vue?vue&type=script&lang=js"
import style0 from "./CommissionDetails.vue?vue&type=style&index=0&id=ccb3c904&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccb3c904",
  null
  
)

export default component.exports